import { render, staticRenderFns } from "./APropos.vue?vue&type=template&id=675706e7&scoped=true&"
import script from "./APropos.vue?vue&type=script&lang=js&"
export * from "./APropos.vue?vue&type=script&lang=js&"
import style0 from "./APropos.vue?vue&type=style&index=0&id=675706e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675706e7",
  null
  
)

component.options.__file = "APropos.vue"
export default component.exports